/* eslint-disable unicorn/no-null */
/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
/* eslint-disable unicorn/consistent-function-scoping */
import {formatQualificationDateToPqe} from '../../shared/services/format-pqe'
;(function module() {
  'use strict'

  angular
    .module('app.ui.form.ctrls')
    .controller('RecommendationListingController', [
      '$scope',
      '$log',
      '$location',
      'usSpinnerService',
      '$window',
      '$uibModal',
      '$sce',
      'SharedApi',
      'RecommendationListingApi',
      'EmployersApi',
      'ApplicationsApi',
      'ApplicationStagesApi',
      'NotesApi',
      'userService',
      'CandidateProfileApi',
      '$rootScope',
      'socket',
      '$timeout',
      'PositionApi',
      function controller(
        $scope,
        $log,
        $location,
        usSpinnerService,
        $window,
        $uibModal,
        $sce,
        SharedApi,
        RecommendationListingApi,
        EmployersApi,
        ApplicationsApi,
        ApplicationStagesApi,
        NotesApi,
        userService,
        CandidateProfileApi,
        $rootScope,
        socket,
        $timeout,
        PositionApi
      ) {
        let vm = this

        socket.on('POSITION_RECOMMENDATION_GENERATED', async positionId => {
          $timeout(async () => {
            if (
              Number.parseInt(vm.positionId, 10) ===
                Number.parseInt(positionId, 10) &&
              $location.url().contains('matching-lawyers')
            ) {
              const {
                data: recommendationList,
              } = await RecommendationListingApi.getPositionRecommendations(
                vm.positionId
              )

              vm.loadRecommendationListing(recommendationList)
              $scope.$applyAsync()
            }
          }, 1500)
        })
        const dateFilterParameters = {
          suppressAndOrCondition: true,
          inRangeInclusive: true,
          comparator: function(filterLocalDateAtMidnight, cellValue) {
            const dateAsString = moment(cellValue).format('DD/MM/YYYY')
            const dateParts = dateAsString.split('/')
            const cellDate = new Date(
              Number(dateParts[2]),
              Number(dateParts[1]) - 1,
              Number(dateParts[0])
            )

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0
            }

            if (cellDate < filterLocalDateAtMidnight) {
              return -1
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1
            }
          },
        }

        function renderDateTimeColumn(parameters) {
          return parameters.value
            ? `<span>` +
                moment(parameters.value).format('DD-MMM-YYYY HH:mm') +
                `</span>`
            : ' '
        }

        function renderDateMonthColumn(parameter) {
          return parameter.value
            ? `<span>` + moment(parameter.value).format('MMM-YY') + `</span>`
            : ' '
        }

        function renderDateColumn(parameter) {
          return parameter.value
            ? `<span>` +
                moment(parameter.value).format('DD-MMM-YYYY') +
                `</span>`
            : ' '
        }

        function renderStatusColumn(parameter) {
          let color = 'Red'
          if (parameter.value === 'Active') color = 'Yellow'
          else if (parameter.value === 'Accepted') color = 'Green'
          else if (parameter.value === 'Rejected by LexStep') color = 'Orange'
          return (
            '<span class="round-circle"style="background:' +
            color +
            ';"> </span>' +
            '<span> ' +
            parameter.value +
            '</span>'
          )
        }

        function renderSubStageColumn(parameter) {
          const substage = vm.allApplicationStagesList.find(
            stage => stage.name === parameter.value
          )
          return (
            '<span class="round-circle" style="background:' +
            substage.color +
            ';"> </span>' +
            '<span> ' +
            parameter.value +
            '</span>'
          )
        }

        function renderInterestColumn(parameter) {
          return parameter.value
            ? parameter.value === 'Likely Interested'
              ? `<span class="round-circle" style="background:green;"></span><span>${parameter.value}</span>`
              : parameter.value === 'Not Interested'
              ? `<span class="round-circle" style="background:red;"></span><span>${parameter.value}</span>`
              : `<span>${parameter.value}</span>`
            : `<span>${parameter.value}</span>`
        }

        const columnDefs = [
          {
            columnGroupShow: undefined,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            width: 134,
            filter: false,
            resizable: false,
          },
          {
            headerName: 'Match Details',
            children: [
              {
                headerName: 'Candidate Interest',
                field: 'interest',
                rowGroupIndex: 0,
                columnGroupShow: undefined,
                cellRenderer: renderInterestColumn,
              },
              {
                headerName: 'Prev-Applied to Employer (reg)',
                field: 'lastAppliedDateRegularCustom',
                cellRenderer: 'agGroupCellRenderer',
                cellRendererParams: {
                  innerRenderer: renderDateTimeColumn,
                },
                filter: 'date',
                columnGroupShow: undefined,
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Prev-Applied to Employer (spec)',
                field: 'lastAppliedDateSpecConnect',
                cellRenderer: 'agGroupCellRenderer',
                cellRendererParams: {
                  innerRenderer: renderDateTimeColumn,
                },
                filter: 'date',
                columnGroupShow: undefined,
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Employer Followed',
                field: 'matchingEmployerFollowed',
              },
              {
                headerName: 'Position Hidden',
                field: 'matchingPositionHidden',
              },
              {
                headerName: 'Employer Hidden',
                field: 'matchingEmployerHidden',
              },
            ],
          },
          {
            headerName: 'Candidate Details',
            children: [
              {
                headerName: 'Candidate Status',
                field: 'candidateDetails.approvalStatus',
              },
              {
                headerName: 'Candidate Agent',
                field: 'candidateAgentEmail',
              },
              {
                headerName: 'Candidate ID',
                field: 'candidateDetails.id',
                filter: 'agTextColumnFilter',
                columnGroupShow: undefined,
              },
              {
                headerName: 'Email',
                field: 'candidateDetails.email',
                filter: 'agTextColumnFilter',
              },
              {
                headerName: 'Phone #',
                field: 'candidateDetails.phone',
                filter: 'agTextColumnFilter',
              },
              {
                headerName: 'Referral Code',
                field: 'candidateDetails.referralCode',
                filter: 'agTextColumnFilter',
              },
              {
                headerName: 'Platform Access',
                field: 'candidateDetails.platformAccess',
              },

              {
                headerName: 'Referred By',
                field: 'candidateDetails.referredBy',
                filter: 'agTextColumnFilter',
                onCellClicked: redirectToReferrals,
                cellRenderer: function(parameter) {
                  return parameter.value
                    ? `<span class="text-info pointer"/>${parameter.value}</span>`
                    : ``
                },
              },
              {
                headerName: 'IP Address',
                field: 'candidateDetails.ip',
              },
            ],
          },
          {
            headerName: 'Candidate Profile',
            children: [
              {
                headerName: 'Candidate Name',
                field: 'candidateProfile.fullName',
                onCellClicked: viewProfile,
                filter: 'agTextColumnFilter',
                cellRenderer: function(parameter) {
                  return parameter.value
                    ? `<span class="text-info pointer"/>${parameter.value}</span>`
                    : ``
                },
                columnGroupShow: undefined,
              },
              {
                headerName: 'Qualification Date',
                field: 'candidateProfile.qualificationDate',
                cellRenderer: renderDateMonthColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'PQE',
                field: 'candidateProfile.pqe',
                filter: 'agNumberColumnFilter',

                filterParams: {
                  comparator: function(a, b) {
                    var numberA = Number.parseFloat(a)
                    var numberB = Number.parseFloat(b)
                    if (numberA > numberB) {
                      return 1
                    }

                    return numberA < numberB ? -1 : 0
                  },
                  numberParser: text => {
                    return Number.parseFloat(text)
                  },
                  inRangeInclusive: true,
                  includeBlanksInRange: true,
                  includeBlanksInLessThan: true,
                  includeBlanksInGreaterThan: true,
                },
              },
              {
                headerName: 'Current Location',
                field: 'candidateProfile.currentLocation',
              },
              {
                headerName: 'Languages',
                field: 'candidateProfile.languages',
              },
              {
                headerName: 'Jurisdiction(s) of Qualification',
                field: 'candidateProfile.jurisdictions',
              },
              {
                headerName: 'University',
                field: 'candidateProfile.school',
              },
              {
                headerName: 'Nationality',
                field: 'candidateProfile.nationality',
              },
            ],
          },
          {
            headerName: 'Candidate Experience',
            children: [
              {
                headerName: 'Current Employer',
                field: 'currentExperience.employer.name',
                columnGroupShow: undefined,
              },
              {
                headerName: 'Current Employer Type',
                field: 'currentExperience.employerType',
              },
              {
                headerName: 'Current Employer Selectivity',
                field: 'currentExperience.employer.selectivity',
              },
              {
                headerName: 'Current Job Title',
                field: 'currentExperience.jobTitle',
              },
              {
                headerName: 'Current Practice Areas',
                field: 'currentExperience.specialties',
              },
              {
                headerName: 'Current Occupation',
                field: 'currentExperience.occupation',
              },
              {
                headerName: 'Current Contract',
                field: 'currentExperience.contractType',
              },
              {
                headerName: 'Current Salary Currency',
                field: 'currentExperience.salary.salaryUnit',
              },
              {
                headerName: 'Current Salary Amount',
                field: 'currentExperience.salary.salaryAmount',
              },
              {
                headerName: 'Current Salary Period',
                field: 'currentExperience.salary.salaryPeriod',
              },
              {
                headerName: 'Current Bonus Currency ',
                field: 'currentExperience.salary.bonusUnit',
              },
              {
                headerName: 'Current Bonus Amount',
                field: 'currentExperience.salary.bonusAmount',
              },
            ],
          },
          {
            headerName: 'Candidate Preferences',
            children: [
              {
                headerName: 'Practice Area Preference',
                field: 'legalCandidatePracticeAreas',
                columnGroupShow: undefined,
              },
              {
                headerName: 'Location Preference',
                field: 'candidatePreference.locations',
                columnGroupShow: undefined,
              },
              {
                headerName: 'Contract Preference',
                field: 'candidatePreference.contracts',
                cellRenderer: function(parameter) {
                  return ` <li class="label label-info text-uppercase margin-r5" style="background-color : #daf0f8; color: black;">
                ${parameter.value}
              </li> `
                },
              },
              {
                headerName: 'Occupation Preference',
                field: 'candidatePreference.occupations',
                cellRenderer: function(parameter) {
                  return ` <li class="label label-info text-uppercase margin-r5" style="background-color : #daf0f8; color: black;">
                ${parameter.value}
              </li> `
                },
              },
              {
                headerName: 'Employer Type Preference',
                field: 'candidatePreference.legalEmployerType',
              },
              {
                headerName: 'Employers Followed',
                field: 'followEmployersName',
              },
              {
                headerName: 'Employers Hidden',
                field: 'hiddenEmployersName',
              },
              {
                headerName: 'Positions Applied',
                field: '',
              },
              {
                headerName: 'Positions Hidden',
                field: '',
              },
            ],
          },
          {
            headerName: 'Candidate Activity',
            children: [
              {
                headerName: 'Candidate Status',
                field: 'candidateActivity.candidateStatus',
              },
              {
                headerName: 'Last Login',
                field: 'candidateActivity.lastLogin',
                cellRenderer: renderDateTimeColumn,
                columnGroupShow: undefined,
                filter: 'date',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Approval Date',
                field: 'candidateActivity.approvalAcceptDate',
                cellRenderer: renderDateTimeColumn,
                filter: 'date',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Request Access Date',
                field: 'candidateActivity.approvalRequestDate',
                cellRenderer: renderDateTimeColumn,
                filter: 'date',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Signup Date',
                field: 'candidateActivity.created',
                cellRenderer: renderDateTimeColumn,
                filter: 'date',
                filterParams: dateFilterParameters,
              },
              {
                headerName: '# Logins',
                field: 'candidateActivity.loginCount',
              },
              {
                headerName: '# Conversation Notes',
                field: 'candidateActivity.totalConversationNote',
              },
              {
                headerName: 'Last Conversation Date',
                field: 'candidateActivity.lastConversationNote',
                cellRenderer: renderDateTimeColumn,
                filter: 'date',
                filterParams: dateFilterParameters,
              },
              {
                headerName: '# Employers Followed',
                field: 'followEmployer.length',
              },

              {
                headerName: '# Employers Hidden',
                field: 'hiddenEmployer.length',
              },
              {
                headerName: '# Positions Hidden',
                field: 'hiddenPosition.length',
              },
              {
                headerName: '# Positions Applied: Reg/Cust',
                field: 'totalAppliedPositionRegularCustom',
              },
              {
                headerName: '# Positions Applied: Spec/Con',
                field: 'totalAppliedPositionSpecConnect',
              },
              {
                headerName: 'Recently Moved',
                field: 'recentlyMoved',
              },
              {
                headerName: 'Email Alerts: In-House ATS-Links',
                field: 'emailAlertWeeklyInHouseATS',
              },
              {
                headerName: 'Email Alerts: Daily + Adhoc Matches',
                field: 'emailAlertDailyMatches',
              },
            ],
          },
        ]
        const masterDetailColumns = [
          {
            headerName: 'Position Details',
            children: [
              {
                headerName: 'Position Title',
                field: 'position.title',
                cellRenderer: function(parameter) {
                  return parameter.value
                    ? `<span class="text-info pointer"/>${parameter.value}</span>`
                    : ``
                },
                columnGroupShow: undefined,
                onCellClicked: openPositionDetailModal,
                filter: 'agTextColumnFilter',
              },
              {headerName: 'Req. PQE', field: 'position.rPQE', width: 125},
              {headerName: 'Location', field: 'position.locations'},
              {headerName: 'Practice Areas', field: 'position.specialties'},
              {headerName: 'Contract', field: 'position.contractType'},
              {headerName: 'Occupation', field: 'position.occupation'},
              {
                headerName: 'Regular ATS Link',
                field: 'position.externalUrl',
                filter: false,
                cellRenderer: function(parameter) {
                  const positionUrl = parameter.value
                    ? parameter.value.match(/http/)
                      ? parameter.value
                      : 'http://'.concat(parameter.value)
                    : parameter.value
                  return parameter.value
                    ? `<span class="text-info pointer"/><a style="color:#4c9bda" href=${positionUrl} target="_blank"/>${parameter.value}</span>`
                    : ``
                },
              },
            ],
          },
          {
            headerName: 'Listing Details',
            children: [
              {
                headerName: 'LexStep Position ID',
                field: 'position.id',
                filter: 'agTextColumnFilter',
              },
              {headerName: '# Applicants', field: 'position.applicantCount'},
              {
                headerName: 'Listing Type',
                field: 'position.type',
                columnGroupShow: undefined,
              },
              {headerName: 'Position Visibility', field: 'position.visible'},
              {
                headerName: 'Uploaded',
                field: 'position.created',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Expired',
                field: 'position.expiresAt',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
            ],
          },
          {
            headerName: 'Application Details',
            children: [
              {
                headerName: 'Application ID',
                field: 'id',
                filter: 'agTextColumnFilter',
              },
              {
                headerName: 'Application Date',
                field: 'created',
                columnGroupShow: undefined,
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Submission Date',
                field: 'submittedAt',
                columnGroupShow: undefined,
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
                cellClass: 'cellEditable',
              },
              {
                headerName: 'CV',
                field: 'cvUrl',
                filter: false,
                columnGroupShow: undefined,
                cellRenderer: function(parameter) {
                  if (parameter.value)
                    return `<center class=""><img class="" style="width: 28px" src="/images/resume.png" /></center>`
                  if (parameter.value !== undefined)
                    return `<center class=""><img class=" disabled-icon" style="width: 28px" src="/images/resume.png" /></center>`
                },
                width: 100,
                onCellClicked: cvCellClicked,
              },
              {
                headerName: 'Stage',
                field: 'parentApplicationStage',
              },
              {
                headerName: 'Sub-Stage',
                field: 'applicationStage',
                columnGroupShow: undefined,
                cellRenderer: renderSubStageColumn,
              },
              {
                headerName: 'Last Stage Change',
                field: 'lastStageChangeAt',
                cellRenderer: renderDateColumn,
                filter: 'agDateColumnFilter',
                filterParams: dateFilterParameters,
              },
              {
                headerName: 'Status',
                field: 'status',
                columnGroupShow: undefined,
                cellRenderer: renderStatusColumn,
              },
              {
                headerName: 'Source',
                field: 'isOffPlatform',
                width: 120,
              },
              {
                headerName: 'Application Candidate Agent',
                field: 'applicationCandidateAgentEmail',
              },
              {
                headerName: 'Application Employer Agent',
                field: 'applicationEmployerAgentEmail',
              },
              {
                headerName: 'Application History',
                field: 'history',
                columnGroupShow: undefined,
                filter: false,
                cellRenderer: function() {
                  return `<center><span class="fa fa-history"/></center>`
                },
                onCellClicked: openHistoryModal,
              },
            ],
          },
        ]

        const masterDetailColumnDef = {
          detailGridOptions: {
            defaultColDef: {
              sortable: true,
              filter: true,
              enablePivot: true,
              enableRowGroup: true,
              enableValue: true,
              resizable: true,
              columnGroupShow: 'open',
              menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
            },
            columnDefs: masterDetailColumns,
            getContextMenuItems,
          },
          template:
            '<div class="master-grid">' +
            '  <div ref="eDetailGrid" style="height: 100%;"></div>' +
            '</div>',
          getDetailRowData: function(parameter) {
            let payload = {
              candidateId: parameter.data.candidateDetails.id,
              employerId: Number(vm.employerId),
              miniGrid: true,
            }
            ApplicationsApi.getApplicationListing(payload)
              .then(async ({data, status}) => {
                if (status === 200) {
                  const [
                    {data: applicationStagesList},
                    {data: applicationStagesHierarchialList},
                  ] = await Promise.all([
                    ApplicationStagesApi.getAllApplicationStages(),
                    ApplicationStagesApi.getAllApplicationStages({
                      hierarchy: true,
                    }),
                  ])
                  vm.applicationStagesHierarchialList = applicationStagesHierarchialList
                  vm.applicationSubStagesList = applicationStagesList
                    .filter(({parentId}) => parentId !== null)
                    .sort((a, b) => Number(a.parentId) - Number(b.parentId))

                  vm.allApplicationStagesList = applicationStagesList
                  parameter.successCallback(
                    setMasterGridApplicationsListingData(data)
                  )
                }
              })
              .catch()
          },
        }

        const gridOptions = {
          defaultColDef: {
            sortable: true,
            filter: true,
            enablePivot: true,
            enableRowGroup: true,
            enableValue: true,
            columnGroupShow: 'open',
            resizable: true,
            menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
          },
          masterDetail: true,
          embedFullWidthRows: true,
          isRowMaster: function(dataItem) {
            return Boolean(
              dataItem.lastAppliedDateRegularCustom ||
                dataItem.lastAppliedDateSpecConnect
            )
          },
          detailRowHeight: 300,
          detailCellRendererParams: masterDetailColumnDef,
          onFilterChanged: onFilterChanged,
          onModelUpdated: updateGridGroupPipeline,
          onGridReady: function() {
            initializeRecommendationListing()
          },
          floatingFilter: true,
          suppressCsvExport: true,
          groupDefaultExpanded: 1,
          groupUseEntireRow: true,
          columnDefs: columnDefs,
          animateRows: true,
          enableCellChangeFlash: true,
          groupSelectsChildren: true,
          rowData: [],
          rowSelection: 'multiple',
          rowGroupPanelShow: 'always',
          pivotPanelShow: 'always',
          groupSelectsFiltered: true,

          postProcessPopup: function(parameter) {
            if (parameter.type !== 'columnMenu') {
              return
            }

            var columnId = parameter.column.getId()
            if (
              columnId === 'lawyerPractices' ||
              columnId === 'currentPracticeArea' ||
              columnId === 'state'
            ) {
              parameter.ePopup.style.width = '350px'
            }
          },
          groupRowRenderer: 'agGroupCellRenderer',
          groupRowRendererParams: {
            checkbox: true,
          },
          onSelectionChanged: onSelectionChanged,

          sideBar: {
            toolPanels: ['columns', 'filters'],
            defaultToolPanel: false,
          },
          statusBar: {
            statusPanels: [
              {statusPanel: 'agTotalRowCountComponent', align: 'left'},
              {statusPanel: 'agFilteredRowCountComponent', align: 'left'},
              {statusPanel: 'agSelectedRowCountComponent'},
              {statusPanel: 'agAggregationComponent'},
            ],
          },

          overlayLoadingTemplate:
            '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
          suppressCopyRowsToClipboard: true,
          enableRangeSelection: true,
          enableCharts: true,
          onColumnRowGroupChanged: updateGridGroupPipeline,
          getContextMenuItems,
        }

        vm.gridOptions = gridOptions
        vm.gridName = 'recommendation'
        function openHistoryModal(parameter) {
          const applicationHistoryModalInstance = $uibModal.open({
            templateUrl: 'application-history-modal.html',
            controller: 'ApplicationHistoryController',
            controllerAs: 'ctrl',
            windowClass: 'application-history-modal',
            backdrop: 'static',
            resolve: {
              isNote: function() {
                return parameter.colDef.field === 'note'
              },
              applicationId: function() {
                return parameter.data.id
              },
              agentsList: function() {
                return vm.agentsList
              },
              isOffPlatform: function() {
                return parameter.data.isOffPlatform
              },
              stagesList: function() {
                return vm.allApplicationStagesList
              },
              enableMasterGrid: function() {
                return true
              },
            },
          })
          applicationHistoryModalInstance.result.then(
            latestNote => {
              const selectedRow = [
                Object.assign(parameter.data, {note: latestNote}),
              ]
              vm.gridOptions.api.updateRowData({
                update: selectedRow,
              })
            },
            () => {}
          )
        }

        vm.helpTooltip = {
          name: 'Help',
          content: $sce.trustAsHtml(recommendationHelpContent),
        }

        const setMasterGridApplicationsListingData = applicationRecord => {
          return applicationRecord.map(data => {
            setMasterGridPositionColumnData(data, vm, applicationRecord)
            data.applicationCandidateAgentEmail = data.userAgentId
              ? vm.agentsList.find(agent => agent.id === data.userAgentId) &&
                vm.agentsList.find(agent => agent.id === data.userAgentId).email
              : ''
            data.applicationEmployerAgentEmail = data.employerAgentId
              ? vm.agentsList.find(
                  agent => agent.id === data.employerAgentId
                ) &&
                vm.agentsList.find(agent => agent.id === data.employerAgentId)
                  .email
              : ''
            const applicationStage = vm.applicationSubStagesList.find(
              ({id}) => data.stageId === id
            )
            data.applicationStage = applicationStage.name
            const parentApplicationStage = vm.allApplicationStagesList.find(
              ({id}) => applicationStage.parentId === id
            )
            data.parentStageId = parentApplicationStage.id
            data.parentApplicationStage = parentApplicationStage.name
            data.isOffPlatform = data.isOffPlatform ? 'OffPlatform' : 'Platform'
            return data
          })
        }

        function openPositionDetailModal(parameter) {
          if (parameter.data.position) {
            positionDetailModal(
              parameter.data.position,
              parameter.data.employer
            )
          }
        }

        const positionDetailModal = (position, employer) => {
          employer.type =
            employer.type.length > 0
              ? vm.legalEmployerTypeList
                  .filter(({id}) =>
                    employer.type.find(specialty => specialty.id === id)
                  )
                  .map(specialty => specialty.name)
              : ''
          position.employer = employer
          $uibModal.open({
            templateUrl: 'position-details-modal.html',
            windowClass: 'position-modal-window',
            controller: 'PositionDetailsController',
            controllerAs: 'ctrl',
            resolve: {
              position: function() {
                return position
              },
              listingName: function() {
                return vm.gridName
              },
            },
          })
        }

        function onFilterChanged() {
          const model = vm.gridOptions.api.getFilterModel()

          vm.filterCount = Object.keys(model).length
          // eslint-disable-next-line angular/document-service
          let filterTextBoxValue = document.querySelector('#filter-text-box')
            .value
          if (filterTextBoxValue.length > 0) {
            vm.filterCount += 1
          }

          updatePipelineCountFromGrid()
        }

        // TODO: on grid functionality
        function updatePipelineCountFromGrid() {
          vm.gridOptions.api.forEachNode(node => {
            if (node.key) {
              vm.groupList.map(row => {
                if (row.id === node.id) {
                  row.applicationsCount = node.allChildrenCount
                  return row
                }

                return row
              })
            }
          })
          $scope.$applyAsync()
        }

        // TODO: on grid action items functionality
        function updateGridGroupPipeline() {
          vm.groupList = []

          vm.gridOptions.api.forEachNode(node => {
            if (node.key) {
              let hasChild = true
              if (
                _.isEmpty(node.childrenMapped) ||
                'undefined' in node.childrenMapped
              )
                hasChild = false
              vm.groupList.push({
                name: node.key,
                applicationsCount: node.allChildrenCount,
                color: node.leafGroup
                  ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16)
                  : lighten('#5e5e5e', (node.level + 1) * 10),
                id: node.id,
                intId: Number(node.id) * -1,
                level: node.level,
                parentID: node.parent.id,
                hasChild: hasChild,
                isHidden: node.level !== 0,
              })
            }
          })
          $log.debug('vm.groupList', vm.groupList)
          $scope.$applyAsync()
        }

        vm.hideAccounts = () => {
          let currentActiveFilters = vm.gridOptions.api.getFilterModel()
          if (vm.actionsFunctions[0].hideAccounts === true) {
            let hiddenData = vm.recommendationListing.filter(
              ({candidateDetails}) =>
                candidateDetails.email &&
                candidateDetails.email.toLowerCase().includes('@lexstep') ===
                  false &&
                candidateDetails.email &&
                candidateDetails.email.toLowerCase().includes('@emumba') ===
                  false
            )
            vm.gridOptions.api.setRowData(hiddenData)
          } else {
            vm.gridOptions.api.setRowData(vm.recommendationListing)
          }

          vm.gridOptions.api.setFilterModel(currentActiveFilters)
          vm.actionsFunctions[0].hideAccounts = !vm.actionsFunctions[0]
            .hideAccounts
          if (vm.actionsFunctions[0].funcName === 'Hide Test Accounts')
            vm.actionsFunctions[0].funcName = 'Show Test Accounts'
          else vm.actionsFunctions[0].funcName = 'Hide Test Accounts'
          vm.gridOptions.api.deselectAll()
          onSelectionChanged()
          updateGridGroupPipeline()
        }

        function viewProfile(parameter) {
          if (parameter.data.candidateDetails.approvalStatus === 'New User') {
            $window.open(
              '/profile?user=' + parameter.data.candidateDetails.id,
              '_blank'
            )
          } else vm.candidateProfile(parameter.data.candidateDetails.id)
        }

        vm.candidateProfile = code => {
          modalInstance = $uibModal.open({
            templateUrl: 'candidateProfileModal.html',
            windowClass: 'app-candidate-profile-modal-window',
            controller: 'CandidateProfileModalController',
            resolve: {
              data: function() {
                return code
              },
            },
          })
        }

        function cvCellClicked(parameter) {
          if (parameter.data.cvUrl)
            getApplicationResume(parameter.data.id, parameter.data.cvUrl)
        }

        vm.splitGrid = value => {
          vm.showCv.isShow = value
          const agGridListingDiv = document.querySelector(`#${vm.gridName}`)
          const cvDiv = document.querySelector(`#myCV`)
          agGridListingDiv.style.height = window.innerHeight - 235 + 'px'
          agGridListingDiv.style.padding = 0
          cvDiv.style.height = window.innerHeight - 235 + 'px'
          if (value) {
            agGridListingDiv.style.width = '65%'
            agGridListingDiv.classList.add('col-md-7')
          } else agGridListingDiv.style.width = '100%'
        }

        vm.applicationsResume = []
        const getApplicationResume = async (applicationId, cvUrl) => {
          vm.showCv = {applicationId}
          vm.showCv.isDoc = false
          if (cvUrl.includes('.doc')) {
            vm.showCv.isDoc = true
          } else vm.splitGrid(true)
          const resumeFound = vm.applicationsResume.find(
            resume => resume.applicationId === applicationId
          )
          if (resumeFound) {
            vm.showCv.path = $sce.trustAsResourceUrl(resumeFound.url)
            if (vm.showCv.isDoc)
              vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId)
            else vm.showCv.display = vm.showCv.path
          } else {
            startSpinner('spinner-resume')
            const {
              status,
              data: resume,
            } = await ApplicationsApi.getApplicationResume(applicationId)
            if (status === 200) {
              if (resume.statusCode === 404) {
                if (cvUrl.includes('.doc')) vm.splitGrid(true)
                vm.showCv.isNotFound = true
              } else {
                const arrayBufferView = new Uint8Array(resume.data)
                const blob = vm.showCv.isDoc
                  ? new Blob([arrayBufferView], {
                      type: 'application/msword;base64',
                    })
                  : new Blob([arrayBufferView], {
                      type: 'application/pdf;base64',
                    })
                const urlCreator = $window.URL || $window.webkitURL
                const resumeUrl = urlCreator.createObjectURL(blob)
                vm.showCv.path = $sce.trustAsResourceUrl(resumeUrl)
                if (vm.showCv.isDoc)
                  vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId)
                else vm.showCv.display = vm.showCv.path

                vm.applicationsResume = [
                  ...vm.applicationsResume,
                  {
                    applicationId,
                    url: resumeUrl,
                  },
                ]
              }

              stopSpinner('spinner-resume')
            }
          }

          $scope.$applyAsync()
        }

        vm.downloadDocFormatCV = (cvUrl, path, applicationId) => {
          const format = cvUrl
            .split('.')
            .slice(1)
            .join('')

          let a = document.createElement('a')
          document.body.append(a)
          a.style = 'display: none'
          a.href = path
          a.download = `application-${applicationId}.${format}`
          a.click()
        }

        function onSelectionChanged() {
          vm.selectedRows = vm.gridOptions.api.getSelectedRows()
          vm.selectedRowsLength = vm.selectedRows.length
          hideShowDropdownActionItem()
        }

        const hideShowDropdownActionItem = () => {
          vm.multiSelectOptions = undefined

          const functionName = vm.actionsFunctions[0].funcName
          const hideAccounts = vm.actionsFunctions[0].hideAccounts
          vm.actionsFunctions = [
            {
              funcName: functionName,
              leftClick: vm.hideAccounts,
              values: vm.recommendationListing,
              hideAccounts: hideAccounts,
            },
          ]
          if (vm.selectedRowsLength > 0) {
            vm.multiSelectOptions = [
              {
                count: vm.selectedRowsLength,
              },
              {
                funcName: 'Clear Selection',
                function: vm.clearSelection,
              },
            ]
            const functionName = vm.actionsFunctions[0].funcName
            const hideAccounts = vm.actionsFunctions[0].hideAccounts
            vm.actionsFunctions = [
              {
                funcName: functionName,
                leftClick: vm.hideAccounts,
                values: vm.recommendationListing,
                hideAccounts: hideAccounts,
              },
            ]
            vm.gridDataActions = [
              {
                count: vm.selectedRowsLength,
              },
            ]
          }

          $scope.$applyAsync()
        }

        // On clicking any referral code it will redirect on referral page with specific code filter
        function redirectToReferrals(parameter) {
          if (
            parameter.data.candidateDetails.referredById &&
            parameter.data.candidateDetails.referredBy !== ''
          )
            $window.open(
              '/admin/referral-listing?filterName=referralCode&filterValue=' +
                parameter.data.candidateDetails.referredById,
              '_blank'
            )
        }

        function getContextMenuItems(parameter) {
          var result = [
            {
              name: 'Open profile in new tab ',
              action: function() {
                if (parameter.node.data.lawyer_Status === 'NewUser') {
                  $window.open(
                    '/profile?user=' + parameter.node.data.candidateDetails.id,
                    '_blank'
                  )
                } else
                  $window.open(
                    '/admin/lawyer-profile?user=' +
                      parameter.node.data.candidateDetails.id,
                    '_blank'
                  )
              },
            },
            'separator',
            {
              name: 'Expand All Columns',
              action: function() {
                var columnApi = parameter.columnApi.getColumnGroupState()
                columnApi.forEach(item => {
                  parameter.columnApi.setColumnGroupOpened(item.groupId, true)
                })
              },
            },
            {
              name: 'Collapse All Columns',
              action: function() {
                var columnApi = parameter.columnApi.getColumnGroupState()
                columnApi.forEach(item => {
                  parameter.columnApi.setColumnGroupOpened(item.groupId, false)
                })
              },
            },
            'separator',
            'copy',
            'copyWithHeaders',
            'separator',
            'chartRange',
          ]
          vm.isExportAllowed = vm.user.roles.some(
            role => role.id === 'admin' || role.id === 'ops'
          )
          if (vm.isExportAllowed) result.push('export')
          return result
        }

        vm.actionsFunctions = [
          {
            funcName: 'Hide Test Accounts',
            leftClick: vm.hideAccounts,
            values: vm.recommendationListing,
            hideAccounts: true,
          },
        ]

        let modalInstance
        vm.profileLink = id => {
          modalInstance.close()
          $window.open('/admin/lawyer-profile?user=' + id, '_blank')
        }

        vm.filterModel = {}

        vm.createInitialFilterModel = async () => {
          const currentFilterModel = vm.gridOptions.api.getFilterModel()
          const {position} = vm
          const employer = vm.employerFull
          const pqe =
            position.professionId === 'law'
              ? {
                  filterType: 'number',
                }
              : {}

          const employerType =
            position.professionId === 'law'
              ? {
                  filterType: 'set',
                }
              : {}

          if (position.professionId === 'law') {
            const parsePqe = ({minPqe, maxPqe}) => {
              return {
                minPqe:
                  minPqe !== undefined && minPqe !== null
                    ? Number.parseFloat(minPqe)
                    : -2,
                maxPqe:
                  maxPqe !== undefined && maxPqe !== null
                    ? Number.parseFloat(maxPqe)
                    : +11,
              }
            }

            const {minPqe, maxPqe} = parsePqe(position.lawPreferences)

            const paddedMinPqe = minPqe >= -1 ? minPqe - 1 : -2
            const paddedMaxPqe = maxPqe <= 10 ? maxPqe + 1 : 11

            pqe.operator = 'AND'

            pqe.condition1 = {
              filterType: 'number',
              type: 'greaterThanOrEqual',
              filter: paddedMinPqe,
              filterTo: null,
            }

            pqe.condition2 = {
              filterType: 'number',
              type: 'lessThanOrEqual',
              filter: paddedMaxPqe,
              filterTo: null,
            }

            // Employer type
            const {categories} = employer
            const employerTypeSpecialties = categories
              .find(category => category.name === 'Legal Employer Type')
              .specialties.map(({name}) => name)

            employerType.values = employerTypeSpecialties
          }

          // CandidatePreference.occupations
          const occupation = {
            filterType: 'set',
            values: [position.occupation.name],
          }

          // Locations
          const hasLocations = position.locations.length > 0
          const location = hasLocations
            ? {
                values: position.locations.map(location => location.name),
                filterType: 'set',
              }
            : {}

          // Contract type

          const hasContractType =
            position.contractType !== null &&
            position.contractType !== undefined

          const contractType = hasContractType
            ? {
                filterType: 'set',
                values: [position.contractType.name],
              }
            : {}

          const practiceAreas = position.specialties.filter(
            ({categoryId}) => categoryId === 1
          )
          const parentIds = new Set(practiceAreas.map(({parentId}) => parentId))
          const mostSpecificPracticeAreas = practiceAreas.filter(
            ({id}) => !parentIds.has(id)
          )

          const legalCandidatePracticeAreas = {
            filterType: 'set',
            values: mostSpecificPracticeAreas.map(({name}) => name),
          }
          $log.debug(
            'legalCandidatePracticeAreas:',
            legalCandidatePracticeAreas
          )

          vm.filterModel = currentFilterModel

          if (Object.keys(pqe).length > 1) {
            vm.filterModel['candidateProfile.pqe'] = pqe
          }

          if (legalCandidatePracticeAreas.values.length > 0) {
            vm.filterModel.legalCandidatePracticeAreas = legalCandidatePracticeAreas
          }

          if (
            Boolean(employerType) &&
            Boolean(employerType.values) &&
            Boolean(employerType.values.length)
          ) {
            vm.filterModel[
              'candidatePreference.legalEmployerType'
            ] = employerType
          }

          if (hasContractType) {
            vm.filterModel['candidatePreference.contracts'] = contractType
          }

          if (occupation.values.length > 0) {
            vm.filterModel['candidatePreference.occupations'] = occupation
          }

          if (hasLocations) {
            vm.filterModel['candidatePreference.locations'] = location
          }

          vm.gridOptions.api.setFilterModel(vm.filterModel)

          const result = vm.gridOptions.api.getFilterModel()
          return result
        }

        vm.loadRecommendationListing = recommendationRecord => {
          vm.recommendationListing = setRecommendationListingData(
            recommendationRecord
          ).sort((a, b) => (a.interestId > b.interestId ? 1 : -1))

          vm.gridOptions.api.setRowData(vm.recommendationListing)
          vm.createInitialFilterModel()
          // eslint-disable-next-line no-unused-vars
          const updatedFilterModel = vm.gridOptions.api.getFilterModel()
          $rootScope.$broadcast('listing-loaded')

          updateGridGroupPipeline()
        }

        const setRecommendationListingData = recommendationRecord => {
          return recommendationRecord.map(data => {
            data.matchingEmployerFollowed =
              data.followEmployer.length > 0 &&
              data.followEmployer.find(
                employer => employer.id === Number(vm.employerId)
              )
                ? 'Yes'
                : 'No'

            data.matchingPositionHidden =
              data.hiddenPosition.length > 0 &&
              data.hiddenPosition.find(
                position => position.id === Number(vm.positionId)
              )
                ? 'Yes'
                : 'No'

            data.matchingEmployerHidden =
              data.hiddenEmployer.length > 0 &&
              data.hiddenEmployer.find(
                employer => employer.id === Number(vm.employerId)
              )
                ? 'Yes'
                : 'No'

            data.followEmployersName =
              data.followEmployer.length > 0
                ? vm.employersNameList
                    .filter(({id}) =>
                      data.followEmployer.find(employer => employer.id === id)
                    )
                    .map(employer => employer.name)
                : ''
            data.hiddenEmployersName =
              data.hiddenEmployer.length > 0
                ? vm.employersNameList
                    .filter(({id}) =>
                      data.hiddenEmployer.find(employer => employer.id === id)
                    )
                    .map(employer => employer.name)
                : ''

            setRecommendationDetailsColumnData(data)
            setCandidateDetailsColumnsData(data, vm)
            setCandidateProfileColumnsData(data, vm)
            if (
              data.currentExperience.employer &&
              data.currentExperience.employerId
            )
              setCurrentExperienceColumnsData(data, vm)
            setCandidatePreferenceColumnsData(data, vm)
            setCandidateActivityColumnsData(data, vm)
            data.recentlyMoved =
              data.currentExperience.isLastJob &&
              new Date(data.currentExperience.startDate) >=
                new Date(lastSixMonthDate())
                ? 'Yes'
                : 'No'
            return data
          })
        }

        const startSpinner = name => usSpinnerService.spin(name)
        const stopSpinner = name => usSpinnerService.stop(name)

        const initializeRecommendationListing = async () => {
          vm.user = await userService.getUser()
          vm.positionId = $location.search().positionId
          vm.employerId = $location.search().employerId
          vm.innerHeight = $location.search().innerHeight

          startSpinner('recommendation-listing')
          const [
            {data: agentsList},
            {data: locationsList},
            {data: languagesList},
            {data: nationalitiesList},
            {data: schoolList},
            {data: legalPracticeAreaList},
            {data: legalEmployerTypeList},
            {data: legalJurisdictionList},
            {data: contractTypeList},
            {data: occupationList},
            {data: recommendationList},
            {data: employersNameList},
            {data: userLoginActions},
            {data: userAllConversationNotes},
            {data: position},
            {data: employer},
          ] = await Promise.all([
            CandidateProfileApi.getAdminAndCorporateUsers(),
            SharedApi.getAllLocations({
              regions: true,
            }),
            SharedApi.getAllLanguages(),
            SharedApi.getAllNationalities(),
            SharedApi.getAllSchools(),
            SharedApi.getCategoryById(1),
            SharedApi.getCategoryById(2),
            SharedApi.getCategoryById(3),
            SharedApi.getAllContractTypes(),
            SharedApi.getAllOccupations(),
            RecommendationListingApi.getPositionRecommendations(vm.positionId),
            EmployersApi.getAllEmployers({include: ['id', 'name']}),
            SharedApi.getAllActions({
              category: 'user',
              type: 'USER_LOGIN',
              include: true,
            }),
            NotesApi.getAllNotes({
              category: 'Conversation',
              type: 'user',
              includes: true,
            }),
            PositionApi.getPositionById(vm.positionId),
            EmployersApi.getEmployerById(vm.employerId),
          ])
          vm.userLoginActions = userLoginActions
          vm.position = position
          vm.userAllConversationNotes = userAllConversationNotes
          vm.agentsList = agentsList
          vm.legalPracticeAreaList = legalPracticeAreaList.specialties
          vm.legalEmployerTypeList = legalEmployerTypeList.specialties
          vm.jurisdictionList = legalJurisdictionList.specialties
          vm.locationsList = locationsList
          vm.languagesList = languagesList
          vm.nationalitiesList = nationalitiesList
          vm.schoolList = schoolList
          vm.contractTypesList = contractTypeList
          vm.occupationList = occupationList
          vm.employersNameList = employersNameList
          vm.employerFull = employer
          vm.loadRecommendationListing(recommendationList)

          stopSpinner('recommendation-listing')
        }
      },
    ])
})()

const lastSixMonthDate = () => {
  const today = new Date()
  return today.setMonth(today.getMonth() - 6)
}

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  // eslint-disable-next-line radix
  amount = Number.parseInt((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}

const recommendationHelpContent = `
<div>
<p>	Matches helps you identify relevant candidates to scout for each Position, based on LexStep’s matching engine.  It also enables you keep tabs on the status of candidates that have been scouted for the Position at any time and saves a record for future reference; to help with scouting candidates for similar Positions in future.</p>
<b>My Candidates</b>
<p>Filter by “My Candidates” from the toolbar above the grid to display matches from your assigned candidates only.</p>
<b>Filtering</b>
<p>Several Filters are automatically applied by the LexStep matching engine to produce an initial shortlist of Matches based on the Candidate’s PQE, Preferences and the requirements of the Position, including:</p>
<ul>
<li>Practice Area Preference</li>
<li>Location Preference</li>
<li>Contract Preference</li>
<li>Role Preference</li>
<li>Employer Type Preference</li>
<li>PQE</li>
</ul>
<p>A filter icon appears in each relevant column header to show which data points the LexStep matching engine has applied.  You can adjust any of the column filters to refine your search; either by expanding the search or narrowing to be more specific.</p>
<b>Views</b>
<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the “Views” icon in the top right -- either as a Private “Saved View” or Shared with other team members. </p>
<b>Clear</b>
<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data.</p>
<b>Group</b>
<p>The Matches grid is grouped by Match Stage by default. Drag and drop columns to the grouping drop zone in the grid’s top row to group rows by a particular column. You can Expand/Collapse All Rows from the Views icon in the top right to view positions by group.</p>
<b>Sorting</b>
<p>[Coming soon: Matches are sorted by Match Score in descending order, showing the most relevant match first by default.]</p>
<p>You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>
<b>Match Details</b>
<p>Expanding the Match Details column group reveals information on each Candidate’s prior interactions with the relevant Position and Employer.  This data can be used to easily identify and scout candidates that have shown a prior interest in positions at that Employer.</p>
<b>Scouting using Match Stage and Sub-Stage</b>
<p>Match Stage enables you to keep a record of scouted matches for each Position by differentiating between “Matched” and “Scouted” candidates.  Select one or more matches and use the star icon in the toolbar above the grid to change Match stage.</p>
<p>Changing a match’s sub-stage to “Scouted - Shortlisted by LexStep” (or any of the other Scouted sub-stages) will automatically change its parent stage to “Scouted”, and vice versa.  </p>
<p>Once you have scouted the list of Matches to produce a shortlist, you can then use the sub-stage “Scouted - Awaiting Candidate’s Response” to record the status of candidates you have  specifically reached out to.  Likewise if a candidate has responded to your approach and is waiting for further information from you, you can use the sub-stage “Scouted - Candidate Awaiting Response” to help manage the process prior to Application.</p>
<p>If a Scouted candidate goes on to apply for the Position their Application will skip the usual Application sub-stage “Applied - Pending Review” and be fast-tracked to “Shortlisted - Shortlisted for Submission”, to streamline the application management process and save duplicate review.</p>
<b>Scouting using Scout Stage </b>
<p>Scout Stage enables you to scout and keep a record of candidates by scout stage for each Position by differentiating between “Matched” and “Scouted” candidates. </p>
<p>Select one or more matches and use the thumbs up icon in the toolbar above the grid to change Scout Stage.</p>
<p>Changing a match’s stage to “Scouted - Shortlisted by Talent Agent” (or any of the other Scouted sub-stages) will automatically change its parent stage to “Scouted”, and vice versa.</p>
<p>Once you have scouted the list of Matches to produce a shortlist, you can then use the stage “Scouted - Awaiting Candidate’s Response” to record the status of scouted candidates you have specifically reached out to about the Position.</p>
<p>Likewise if a candidate has responded to your approach and is waiting for further information from you before putting themselves forward for the Position, you can use the stage “Scouted - Candidate Awaiting Response” to help manage the process prior to Application.</p>
<p>If a Scouted candidate goes on to apply for the Position their Application will skip the usual Application sub-stage “Applied - Pending Review” and be fast-tracked to “Shortlisted - Shortlisted for Submission”, to streamline the application management process and save duplicate review.</p>
<b>Match Status</b>
<p>You can pass on matches by selecting one or more candidates and using the thumbs down  icon in the toolbar above the grid to change Match Status.</p>
</div> `

const setCandidateDetailsColumnsData = (data, vm) => {
  data.candidateDetails.referralCode = data.candidateDetails.id
  data.candidateAgentEmail = data.candidateDetails.agentId
    ? vm.agentsList.find(agent => agent.id === data.candidateDetails.agentId) &&
      vm.agentsList.find(agent => agent.id === data.candidateDetails.agentId)
        .email
    : 'unassigned'

  const platformAccess = data.candidateDetails.platformAccess
  const leadAccount = data.candidateDetails.leadAccount
  data.candidateDetails.platformAccess = platformAccess
    ? 'Candidate Account'
    : leadAccount
    ? 'Lead Account'
    : 'No Platform Access'

  return data
}

const setCandidateProfileColumnsData = (data, vm) => {
  data.candidateProfile.fullName = `${data.candidateProfile.firstName} ${data.candidateProfile.lastName}`
  data.candidateProfile.pqe = data.candidateProfile.qualificationDate
    ? formatQualificationDateToPqe(data.candidateProfile.qualificationDate)
    : ''
  let currentLocation = ''
  if (data.candidateProfile.currentLocation) {
    currentLocation = vm.locationsList.find(
      location => location.id === data.candidateProfile.currentLocation
    )
  }

  data.candidateProfile.currentLocation = currentLocation
    ? currentLocation.name
    : currentLocation
  data.candidateProfile.languages =
    data.candidateProfile.languages.length > 0
      ? vm.languagesList
          .filter(({code}) =>
            data.candidateProfile.languages.find(
              language => language.code === code
            )
          )
          .map(language => language.name)
      : ''
  data.candidateProfile.jurisdictions =
    data.candidateProfile.jurisdictions.length > 0
      ? vm.jurisdictionList
          .filter(({id}) =>
            data.candidateProfile.jurisdictions.find(
              jurisdiction => jurisdiction.id === id
            )
          )
          .map(jurisdiction => jurisdiction.name)
      : ''
  data.candidateProfile.school = data.candidateProfile.school
    ? vm.schoolList.find(school => school.id === data.candidateProfile.school)
        .name
    : ''
  data.candidateProfile.nationality =
    data.candidateProfile.nationalities &&
    data.candidateProfile.nationalities.length > 0
      ? vm.nationalitiesList
          .filter(({code}) =>
            data.candidateProfile.nationalities.find(
              nationality => nationality.code === code
            )
          )
          .map(nationality => nationality.demonyms[0])
      : ''
  return data
}

const setCurrentExperienceColumnsData = (data, vm) => {
  data.currentExperience.contractType = data.currentExperience.contractTypeId
    ? vm.contractTypesList.find(
        contract => contract.id === data.currentExperience.contractTypeId
      ).name
    : ''
  data.currentExperience.occupation = data.currentExperience.occupationId
    ? vm.occupationList.find(
        occupation => occupation.id === data.currentExperience.occupationId
      ).name
    : ''
  data.currentExperience.specialties =
    data.currentExperience.positionSpecialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.currentExperience.positionSpecialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.currentExperience.employerType =
    data.currentExperience.employerSpecialties.length > 0
      ? vm.legalEmployerTypeList
          .filter(({id}) =>
            data.currentExperience.employerSpecialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  let currentEmployerSelectivity = ''
  if (data.currentExperience.employer.selectivity) {
    for (
      let index = 1;
      index <= data.currentExperience.employer.selectivity;
      index++
    ) {
      currentEmployerSelectivity += '$'
    }
  }

  if (data.currentExperience.employer.selectivity === 0)
    currentEmployerSelectivity = 'Uncategorized'
  data.currentExperience.employer.selectivity = currentEmployerSelectivity

  return data
}

const setCandidateActivityColumnsData = (data, vm) => {
  data.candidateActivity.loginCount =
    vm.userLoginActions.find(
      ({userId}) => userId === data.candidateDetails.id
    ) &&
    Number(
      vm.userLoginActions.find(
        ({userId}) => userId === data.candidateDetails.id
      ).count
    )
  data.candidateActivity.totalConversationNote =
    vm.userAllConversationNotes.find(
      ({userId}) => userId === data.candidateDetails.id
    ) &&
    Number(
      vm.userAllConversationNotes.find(
        ({userId}) => userId === data.candidateDetails.id
      ).count
    )
  data.candidateActivity.lastConversationNote =
    vm.userAllConversationNotes.find(
      ({userId}) => userId === data.candidateDetails.id
    ) &&
    vm.userAllConversationNotes.find(
      ({userId}) => userId === data.candidateDetails.id
    ).created
  data.emailAlertDailyMatches =
    data.candidateActivity.emailSubscription.length > 0
      ? data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'daily_positions_ping'
        ) &&
        data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'daily_positions_ping'
        ).status
      : 'Active'
  data.emailAlertWeeklyInHouseATS =
    data.candidateActivity.emailSubscription.length > 0
      ? data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'weekly_position_ping'
        ) &&
        data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'weekly_position_ping'
        ).status
      : 'Active'

  return data
}

const setCandidatePreferenceColumnsData = (data, vm) => {
  data.legalCandidatePracticeAreas =
    data.candidatePreference.specialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.candidatePreference.specialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.candidatePreference.legalEmployerType =
    data.candidatePreference.specialties.length > 0
      ? vm.legalEmployerTypeList
          .filter(({id}) =>
            data.candidatePreference.specialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.candidatePreference.contracts =
    data.candidatePreference.contracts.length > 0
      ? vm.contractTypesList
          .filter(({id}) =>
            data.candidatePreference.contracts.find(
              contractType => contractType.id === id
            )
          )
          .map(contractType => contractType.name)
      : ''
  data.candidatePreference.occupations =
    data.candidatePreference.occupations.length > 0
      ? vm.occupationList
          .filter(({id}) =>
            data.candidatePreference.occupations.find(
              occupation => occupation.id === id
            )
          )
          .map(occupation => occupation.name)
      : ''
  data.candidatePreference.locations =
    data.candidatePreference.locations.length > 0
      ? vm.locationsList
          .filter(({id}) =>
            data.candidatePreference.locations.find(
              location => location.id === id
            )
          )
          .map(location => location.name)
      : ''
  return data
}

const setMasterGridPositionColumnData = (data, vm, applicationRecord) => {
  data.position.rPQE = `${
    data.position.lawPreferences.minPqe <= 0
      ? 'NQ'
      : data.position.lawPreferences.minPqe
  }${
    data.position.lawPreferences.maxPqe === 11
      ? '+'
      : data.position.lawPreferences.maxPqe <= 0 ||
        data.position.lawPreferences.maxPqe ===
          data.position.lawPreferences.minPqe
      ? ''
      : '-' + data.position.lawPreferences.maxPqe.toString()
  }`
  data.position.visible = data.position.visible ? 'Visible' : 'Invisible'

  data.position.specialties =
    data.position.specialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.position.specialties.find(specialty => specialty.id === id)
          )
          .map(specialty => specialty.name)
      : ''

  data.position.locations =
    data.position.locations.length > 0
      ? vm.locationsList
          .filter(({id}) =>
            data.position.locations.find(location => location.id === id)
          )
          .map(location => location.name)
      : ''

  data.position.contractType = data.position.contractTypeId
    ? vm.contractTypesList.find(
        contract => contract.id === data.position.contractTypeId
      ).name
    : ''
  data.position.occupation = data.position.occupationId
    ? vm.occupationList.find(
        occupation => occupation.id === data.position.occupationId
      ).name
    : ''
  data.position.applicantCount = applicationRecord.filter(
    application => application.position.id === data.position.id
  ).length
  return data
}

const setRecommendationDetailsColumnData = data => {
  if (
    data.matchingPositionHidden === 'Yes' ||
    data.matchingEmployerHidden === 'Yes'
  ) {
    data.interestId = 3
    data.interest = 'Not Interested'
  } else if (
    data.appliedPosition.length > 0 ||
    data.matchingEmployerFollowed === 'Yes'
  ) {
    data.interestId = 1
    data.interest = 'Likely Interested'
    const regularCustomAppliedPosition = data.appliedPosition.find(
      ({lastAppliedDateRegularCustom}) => lastAppliedDateRegularCustom !== null
    )
    if (regularCustomAppliedPosition) {
      data.lastAppliedDateRegularCustom =
        regularCustomAppliedPosition.lastAppliedDateRegularCustom
      data.totalAppliedPositionRegularCustom =
        regularCustomAppliedPosition.totalAppliedPositionRegularCustom
    }

    const specConnectAppliedPosition = data.appliedPosition.find(
      ({lastAppliedDateSpecConnect}) => lastAppliedDateSpecConnect !== null
    )
    if (specConnectAppliedPosition) {
      data.lastAppliedDateSpecConnect =
        specConnectAppliedPosition.lastAppliedDateSpecConnect
      data.totalAppliedPositionSpecConnect =
        specConnectAppliedPosition.totalAppliedPositionSpecConnect
    }
  } else if (data.appliedPosition.length === 0) {
    data.interestId = 2
    data.interest = 'Unknown'
  }

  return data
}



// WEBPACK FOOTER //
// ./scripts/admin-panel/recommendation-listing/recommendation-listing.ctrl.js